import { tokensRaw, useScreenClass } from '@vp/swan';
import styled from 'styled-components';
import { useStepContext } from '../context/StepContext';

const ProgressIndicator = styled.div`
    width: 100%;
    height: ${tokensRaw.SwanSemSpace2};
    background-color: ${tokensRaw.SwanBaseColorGrey200};
`;

const ProgressBarInner = styled.div`
    height: 100%;
    background-color: ${tokensRaw.SwanBaseColorBlue400};
`;

export const ProgressBar = () => {
    const { currentStep, totalSteps } = useStepContext();
    const screenClass = useScreenClass();
    return (
        <div
            style={
                screenClass === 'xs'
                    ? {
                          width: '100%',
                      }
                    : {
                          width: '300px',
                          padding: `0 ${tokensRaw.SwanSemSpace5} ${tokensRaw.SwanSemSpace4}`,
                          alignSelf: 'flex-start',
                      }
            }
        >
            <ProgressIndicator>
                <ProgressBarInner style={{ width: `${(currentStep / (totalSteps - 1)) * 100}%` }} />
            </ProgressIndicator>
        </div>
    );
};
